<style lang="scss">
.talk-input {
  .preview-box-wrap {
    display: flex;
    .thumb {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid #eee;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .preview-box {
      padding: 10px;
      background: #eee;
      font-size: 1.5rem;
      flex: 1;
      margin-left: 20px;
    }
  }
}
</style>

<template>
  <div class="talk-input">
    <div class="talk-input-form" v-if="isEditing">
      <div class="form-group">
        <label for="">人物タイプ</label>
        <select v-model="person_type" class="form-control">
          <option value="man1">男性1</option>
          <option value="man2">男性2</option>
          <option value="man3">男性3</option>
          <option value="man4">男性4</option>
          <option value="man5">男性5</option>
          <option value="man6">男性6</option>
          <option value="man7">男性7</option>
          <option value="man8">男性8</option>
          <option value="man9">男性9</option>
          <option value="man10">男性10</option>
          <option value="man11">男性11</option>
          <option value="man12">男性12</option>
          <option value="man13">男性13</option>
          <option value="man14">男性14</option>
          <option value="man15">男性15</option>
          <option value="man16">男性16</option>
          <option value="man17">男性17</option>
          <option value="man18">男性18</option>
          <option value="man19">男性19</option>
          <option value="man20">男性20</option>
          <option value="woman1">女性1</option>
          <option value="woman2">女性2</option>
          <option value="woman3">女性3</option>
          <option value="woman4">女性4</option>
          <option value="woman5">女性5</option>
          <option value="woman6">女性6</option>
          <option value="woman7">女性7</option>
          <option value="woman8">女性8</option>
          <option value="woman9">女性9</option>
          <option value="woman10">女性10</option>
          <option value="woman11">女性11</option>
          <option value="woman12">女性12</option>
          <option value="woman13">女性13</option>
          <option value="woman14">女性14</option>
          <option value="woman15">女性15</option>
          <option value="woman16">女性16</option>
          <option value="woman17">女性17</option>
          <option value="woman18">女性18</option>
          <option value="woman19">女性19</option>
          <option value="woman20">女性20</option>
          <option value="baby1">赤ちゃん</option>
        </select>
      </div>
      <div class="form-group">
        <label for="">本文</label>
        <quill-editor v-model="text"></quill-editor>
      </div>
      <div class="form-group">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="talk-input-preview input-preview" v-else>
      <div class="preview-box-wrap">
        <div class="thumb">
          <img v-if="person_type === 'man1'" src="@images/man1.jpg" alt="" />
          <img v-if="person_type === 'man2'" src="@images/man2.jpg" alt="" />
          <img v-if="person_type === 'man3'" src="@images/man3.jpg" alt="" />
          <img v-if="person_type === 'man4'" src="@images/man4.jpg" alt="" />
          <img v-if="person_type === 'man5'" src="@images/man5.jpg" alt="" />
          <img v-if="person_type === 'man6'" src="@images/man6.jpg" alt="" />
          <img v-if="person_type === 'man7'" src="@images/man7.jpg" alt="" />
          <img v-if="person_type === 'man8'" src="@images/man8.jpg" alt="" />
          <img v-if="person_type === 'man9'" src="@images/man9.jpg" alt="" />
          <img v-if="person_type === 'man10'" src="@images/man10.jpg" alt="" />
          <img v-if="person_type === 'man11'" src="@images/man11.jpg" alt="" />
          <img v-if="person_type === 'man12'" src="@images/man12.jpg" alt="" />
          <img v-if="person_type === 'man13'" src="@images/man13.jpg" alt="" />
          <img v-if="person_type === 'man14'" src="@images/man14.jpg" alt="" />
          <img v-if="person_type === 'man15'" src="@images/man15.jpg" alt="" />
          <img v-if="person_type === 'man16'" src="@images/man16.jpg" alt="" />
          <img v-if="person_type === 'man17'" src="@images/man17.jpg" alt="" />
          <img v-if="person_type === 'man18'" src="@images/man18.jpg" alt="" />
          <img v-if="person_type === 'man19'" src="@images/man19.jpg" alt="" />
          <img v-if="person_type === 'man20'" src="@images/man20.jpg" alt="" />
          <img
            v-if="person_type === 'woman1'"
            src="@images/woman1.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman2'"
            src="@images/woman2.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman3'"
            src="@images/woman3.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman4'"
            src="@images/woman4.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman5'"
            src="@images/woman5.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman6'"
            src="@images/woman6.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman7'"
            src="@images/woman7.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman8'"
            src="@images/woman8.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman9'"
            src="@images/woman9.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman10'"
            src="@images/woman10.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman11'"
            src="@images/woman11.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman12'"
            src="@images/woman12.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman13'"
            src="@images/woman13.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman14'"
            src="@images/woman14.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman15'"
            src="@images/woman15.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman16'"
            src="@images/woman16.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman17'"
            src="@images/woman17.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman18'"
            src="@images/woman18.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman19'"
            src="@images/woman19.jpg"
            alt=""
          />
          <img
            v-if="person_type === 'woman20'"
            src="@images/woman20.jpg"
            alt=""
          />
          <img v-if="person_type === 'baby1'" src="@images/baby1.jpg" alt="" />
        </div>
        <div class="preview-box" v-html="text"></div>
      </div>
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';

export default {
  props: {
    value: {},
    index: Number,
    id: String,
  },
  data() {
    return {
      isEditing: false,
      text: '',
      person_type: 'man1',
    };
  },
  components: {
    'footer-menu': footerMenu,
  },
  mounted() {
    this.text = this.value.text;
    this.person_type = this.value.person_type;
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          text: this.text,
          person_type: this.person_type,
        },
        action: 'talk',
        id: this.id,
      };
    },
    valid() {
      return this.text.length;
    },
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        if (!this.text.length) {
          alert('本文は必須です');
        }
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
};
</script>
